// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.SurfaceWaterFlowRate {
  color: #fff;
  background-color: #050e25;
  height: 90vh;
  width: 100%;
  margin: 0px;
  padding: 0px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px; }
  .SurfaceWaterFlowRate .expand-container {
    position: absolute;
    top: 65px;
    left: 90px;
    height: 83vh !important;
    width: 92%;
    z-index: 100; }
  .SurfaceWaterFlowRate .mapboxgl-popup-content {
    padding: 0px;
    min-width: 280px;
    opacity: .95;
    border-radius: 4px;
    width: 100% !important;
    background-color: #18244c; }
  .SurfaceWaterFlowRate .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #18244c;
    opacity: .8; }
  .SurfaceWaterFlowRate .mapboxgl-popup-close-button {
    display: none; }
  .SurfaceWaterFlowRate .popup-container {
    display: flex;
    flex-direction: column;
    opacity: .9;
    height: auto;
    padding-top: 12px;
    padding-bottom: 15px;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 1.2rem;
    width: 280px;
    min-width: 280px;
    font-family: "Urbanist";
    background-color: #050E25; }
  .SurfaceWaterFlowRate .popup-content-row {
    display: inline-flex;
    flex-direction: row;
    height: auto;
    justify-content: space-between;
    margin-bottom: 7px; }
  .SurfaceWaterFlowRate .popup-content-label {
    width: 100px;
    min-width: 100px !important;
    margin-right: 5px;
    text-align: end; }
  .SurfaceWaterFlowRate .popup-content-value {
    margin-left: 5px;
    width: 160px;
    max-width: 160px !important;
    text-align: start;
    height: auto; }
  .SurfaceWaterFlowRate .popup-container-location {
    color: #4fc2d9; }
  .SurfaceWaterFlowRate .popup-container h4 {
    font-size: 22px;
    line-height: 22px;
    height: auto;
    color: #4fc2d9; }
  .SurfaceWaterFlowRate .container {
    display: flex;
    padding: 0;
    height: 90%;
    margin-top: 10px;
    max-width: unset;
    width: 97%;
    flex-direction: column; }
    .SurfaceWaterFlowRate .container input,
    .SurfaceWaterFlowRate .container select {
      margin-bottom: 50px; }
    .SurfaceWaterFlowRate .container .main-col {
      max-width: -webkit-fill-available; }
    .SurfaceWaterFlowRate .container .map-title {
      width: auto;
      white-space: nowrap;
      position: absolute;
      left: 59px;
      top: 0px;
      font-size: 1.25rem;
      padding: 5px;
      z-index: 90; }
    .SurfaceWaterFlowRate .container .map-best-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      height: 43vh;
      padding: 0px !important; }
    .SurfaceWaterFlowRate .container .chart-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      margin-top: 20px;
      height: 32vh; }
    .SurfaceWaterFlowRate .container .chart-line-container {
      height: 100%;
      width: 100%;
      width: -webkit-fill-available;
      width: -moz-available;
      width: stretch; }
    .SurfaceWaterFlowRate .container .report-options {
      margin-top: 10px;
      text-align: right;
      margin-right: 14px;
      position: absolute;
      right: 30px; }
      .SurfaceWaterFlowRate .container .report-options button {
        background-color: #fff;
        border: unset;
        margin-left: 10px; }
      .SurfaceWaterFlowRate .container .report-options button img {
        margin-top: 6px;
        vertical-align: unset; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .SurfaceWaterFlowRate .header-container h2 {
    font-size: 25px; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/SurfaceWaterFlowRate/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,WDVqB;ECWrB,yBDEsC;ECDtC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAdoB;EAepB,mBAfoB;EAgBpB,iBAfmB,EAAA;EAMrB;IAYI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,YAAY,EAAA;EAjBhB;IAqBI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB,EAAA;EA1B7B;IA8BI,4BAA4B;IAC5B,WAAW,EAAA;EA/Bf;IAmCI,aAAa,EAAA;EAnCjB;IAuCI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB,EAAA;EAnD7B;IAuDI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB,EAAA;EA3DtB;IA+DI,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe,EAAA;EAlEnB;IAsEI,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY,EAAA;EA1EhB;IA8EI,cAAc,EAAA;EA9ElB;IAkFI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,cAAc,EAAA;EArFlB;IAyFI,aAAa;IACb,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,sBAAsB,EAAA;IA/F1B;;MAmGM,mBAAmB,EAAA;IAnGzB;MAuGM,iCAAiC,EAAA;IAvGvC;MA2GM,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,WAAW,EAAA;IAlHjB;MAsHM,yBD5H0B;MC6H1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,uBAAuB,EAAA;IA5H7B;MAgIM,yBDtI0B;MCuI1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,gBAAgB;MAChB,YAAY,EAAA;IArIlB;MAyIM,YAAY;MACZ,WAAW;MAEX,6BAA6B;MAC7B,qBAAc;MAAd,cAAc,EAAA;IA7IpB;MAiJM,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,WAAW,EAAA;MArJjB;QAwJQ,sBAAsB;QACtB,aAAa;QACb,iBAAiB,EAAA;MA1JzB;QA8JQ,eAAe;QACf,qBAAqB,EAAA;;AAM7B;EACE;IAGM,eAAe,EAAA,EAChB","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 30px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n.SurfaceWaterFlowRate {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 90vh;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n  .expand-container {\n    position: absolute;\n    top: 65px;\n    left: 90px;\n    height: 83vh !important;\n    width: 92%;\n    z-index: 100;\n  }\n\n  .mapboxgl-popup-content {\n    padding: 0px;\n    min-width: 280px;\n    opacity: .95;\n    border-radius: 4px;\n    width: 100% !important;\n    background-color: #18244c;\n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #18244c;\n    opacity: .8;\n  }\n\n  .mapboxgl-popup-close-button {\n    display: none;\n  }\n\n  .popup-container {\n    display: flex;\n    flex-direction: column;\n    opacity: .9;\n    height: auto;\n    padding-top: 12px;\n    padding-bottom: 15px;\n    padding-left: 8px;\n    padding-right: 8px;\n    font-size: 1.2rem;\n    width: 280px;\n    min-width: 280px;\n    font-family: \"Urbanist\";\n    background-color: #050E25;\n  }\n\n  .popup-content-row {\n    display: inline-flex;\n    flex-direction: row;\n    height: auto;\n    justify-content: space-between;\n    margin-bottom: 7px;\n  }\n\n  .popup-content-label {\n    width: 100px;\n    min-width: 100px !important;\n    margin-right: 5px;\n    text-align: end;\n  }\n\n  .popup-content-value {\n    margin-left: 5px;\n    width: 160px;\n    max-width: 160px !important;\n    text-align: start;\n    height: auto;\n  }\n\n  .popup-container-location {\n    color: #4fc2d9;\n  }\n\n  .popup-container h4 {\n    font-size: 22px;\n    line-height: 22px;\n    height: auto;\n    color: #4fc2d9;\n  }\n\n  .container {\n    display: flex;\n    padding: 0;\n    height: 90%;\n    margin-top: 10px;\n    max-width: unset;\n    width: 97%;\n    flex-direction: column;\n\n    input,\n    select {\n      margin-bottom: 50px;\n    }\n\n    .main-col {\n      max-width: -webkit-fill-available;\n    }\n\n    .map-title {\n      width: auto;\n      white-space: nowrap;\n      position: absolute;\n      left: 59px;\n      top: 0px;\n      font-size: 1.25rem;\n      padding: 5px;\n      z-index: 90;\n    }\n\n    .map-best-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      height: 43vh;\n      padding: 0px !important;\n    }\n\n    .chart-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      margin-top: 20px;\n      height: 32vh;\n    }\n\n    .chart-line-container {\n      height: 100%;\n      width: 100%;\n      width: -moz-available;\n      width: -webkit-fill-available;\n      width: stretch;\n    }\n\n    .report-options {\n      margin-top: 10px;\n      text-align: right;\n      margin-right: 14px;\n      position: absolute;\n      right: 30px;\n\n      button {\n        background-color: #fff;\n        border: unset;\n        margin-left: 10px;\n      }\n\n      button img {\n        margin-top: 6px;\n        vertical-align: unset;\n      }\n    }\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  .SurfaceWaterFlowRate {\n    .header-container {\n      h2 {\n        font-size: 25px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
